import script from "./indexAI.vue?vue&type=script&setup=true&lang=js"
export * from "./indexAI.vue?vue&type=script&setup=true&lang=js"

import "./indexAI.vue?vue&type=style&index=0&id=d9b8e990&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9b8e990"]])

export default __exports__